// BrimLight/client/ui/MediaManagerButton.js
import { ComponentBase } from "../core/ComponentBase.js";

export class MediaManagerButton extends ComponentBase {
    static styles = `
        @media (max-width: 767.98px) {
            .media-manager-button-text {
                display: none !important;
            }
        }
    `;

    constructor(config) {
        super(config);
        this.mediaManager = null;
        this.button = null;
        this.applyStyles(); // Apply styles in constructor
    }

   static getDefaultConfig() {
        return {
            buttonClass: "btn btn-outline-secondary header-btn",
            iconClass: "bi bi-images",
            buttonText: "Media Library",
            // showTextOnMobile: false, // Removed as it's no longer needed for this behavior
        };
    }



    async initialize() {
        await super.initialize();
    }

    async handleOpenMediaManager() {
        if (!this.mediaManager) {
            this.mediaManager = await this.createManagedComponent("MediaManager", document.body, {
                instanceId: `${this.config.instanceId}-manager-modal`,
            });
        }

        try {
            // Show the manager. We don't need to handle the returned files here
            // as this is just for browsing/managing.
            await this.mediaManager.show({
                maxFiles: 999, // Allow managing multiple files
                category: 'image' // Default category
            });
        } catch (error) {
            if (error !== 'cancelled') {
                this.log.error("Error opening Media Manager:", error);
            }
        }
    }


    render() {
        if (!this.button) {
            this.button = document.createElement('button');
            this.button.type = 'button';
            this.button.className = this.config.buttonClass;

            // Always apply the custom class to hide text on mobile
            const textSpan = `<span class="ms-2 media-manager-button-text">${this.t(this.config.buttonText)}</span>`;

            this.button.innerHTML = `<i class="${this.config.iconClass}"></i>${textSpan}`;
            this.button.addEventListener('click', () => this.handleOpenMediaManager());
        }
        return this.button;
    }
    
    destroy() {
        this.mediaManager?.destroy();
        super.destroy();
    }
}